/**
 * Keyboard helpers for the build panels.
 *
 * The global `Input` listens on `window` and binds Tab (overlay map), Enter (chat) and
 * Space (dash), calling preventDefault on them — which would break focus navigation
 * and button activation inside panels. While focus is inside a panel we stop those
 * keys from bubbling out to `window`. Escape is left alone so the existing handler
 * still closes the panel.
 */
export function panelKeys(e: KeyboardEvent): void {
  if (e.key === 'Tab') {
    e.stopPropagation();
    return;
  }
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const t = e.target instanceof HTMLElement ? e.target : null;
  if (t?.closest('button, [role="button"], [role="tab"], [role="option"], input, select, textarea, [tabindex]')) e.stopPropagation();
}

/** Spread on a panel root: `<div {...keyTrap}>`. */
export const keyTrap = { onKeyDown: panelKeys, onKeyUp: panelKeys };
